/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} LeadsInputs */

const en_leads = /** @type {(inputs: LeadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leads`)
};

const es_leads = /** @type {(inputs: LeadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leads`)
};

const fr_leads = /** @type {(inputs: LeadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prospects`)
};

const de_leads = /** @type {(inputs: LeadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leads`)
};

const ja_leads = /** @type {(inputs: LeadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リード数`)
};

const zh_leads = /** @type {(inputs: LeadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`潜在客户`)
};

const ar_leads = /** @type {(inputs: LeadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العملاء المحتملون`)
};

const id_leads = /** @type {(inputs: LeadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prospek`)
};

const it_leads = /** @type {(inputs: LeadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lead`)
};

const ru_leads = /** @type {(inputs: LeadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лиды`)
};

const pt_leads = /** @type {(inputs: LeadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leads`)
};

const ko_leads = /** @type {(inputs: LeadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`리드(잠재 고객)`)
};

/**
* | output |
* | --- |
* | "Leads" |
*
* @param {LeadsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const leads = /** @type {((inputs?: LeadsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<LeadsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_leads(inputs)
	if (locale === "es") return es_leads(inputs)
	if (locale === "fr") return fr_leads(inputs)
	if (locale === "de") return de_leads(inputs)
	if (locale === "ja") return ja_leads(inputs)
	if (locale === "zh") return zh_leads(inputs)
	if (locale === "ar") return ar_leads(inputs)
	if (locale === "id") return id_leads(inputs)
	if (locale === "it") return it_leads(inputs)
	if (locale === "ru") return ru_leads(inputs)
	if (locale === "pt") return pt_leads(inputs)
	return ko_leads(inputs)
});